var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyUrl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.528,
    height: 16.534,
    viewBox: "0 0 13.528 16.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-svgrepo-com",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32133",
    "data-name": "Path 32133",
    d: "M17.522,7.255A2.255,2.255,0,0,0,15.267,5H9.255A2.255,2.255,0,0,0,7,7.255v9.019a2.255,2.255,0,0,0,2.255,2.255h6.012a2.255,2.255,0,0,0,2.255-2.255Zm-1.5,0a.752.752,0,0,0-.752-.752H9.255a.752.752,0,0,0-.752.752v9.019a.752.752,0,0,0,.752.752h6.012a.752.752,0,0,0,.752-.752Z",
    transform: "translate(-0.994 -0.994)",
    fill: "#2c2c2c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32134",
    "data-name": "Path 32134",
    d: "M5.255,2.5H12.77a.752.752,0,0,0,0-1.5H5.255A2.255,2.255,0,0,0,3,3.255V13.776a.752.752,0,1,0,1.5,0V3.255A.752.752,0,0,1,5.255,2.5Z",
    fill: "#2c2c2c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyUrl);
export default __webpack_public_path__ + "static/media/copy-url.caa37db2a0556393db9c9058522e4f3c.svg";
export { ForwardRef as ReactComponent };